import { FC } from 'react';
import classNames from 'classnames';

import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';
import { addQueryParam } from '../../../../../../ReactSharedScripts/utils/url';
import { TooltipLanguageCollapseItemContent } from './TooltipLanguageCollapseItemContent';
import { TooltipLanguageItemProps } from './types';
import classes from './styles/index.module.scss';
import RouteLink from '../../../../../../ReactSharedScripts/components/RouteLink';

const TooltipLanguageItem: FC<TooltipLanguageItemProps> = ({
	image,
	name,
	theme,
	languageCode,
	cultureCode,
	isOpened,
	itemClick,
	hasCollapse,
	isDirtyLink,
}) => {
	let langHref = '';
	langHref = languageCode ? addQueryParam(window.location.href, 'lang', languageCode) : langHref;
	langHref = cultureCode ? addQueryParam(langHref, 'cult', cultureCode) : langHref;

	const tooltipLanguageItemClasses = classNames(classes.tooltipItem, classes.tooltipLanguageItem, {
		[classes.tooltipItem_dark]: theme === ThemeStyle.Dark,
		[classes.tooltipItem_light]: theme === ThemeStyle.Light,
	});

	const linkProps = {
		className: tooltipLanguageItemClasses,
		onClick: itemClick,
		href: langHref,
		hasColor: false,
		forceUseLink: true,
	};

	const tooltipItemContent = (
		<TooltipLanguageCollapseItemContent
			image={image}
			name={name}
			isOpened={isOpened}
			hasCollapse={hasCollapse}
		/>
	);

	return (
		<>
			<RouteLink
				{...linkProps}
				useDirty={isDirtyLink}
			>
				{tooltipItemContent}
			</RouteLink>
		</>
	);
};

export { TooltipLanguageItem };
